import { Button } from "@chakra-ui/button"
import { ContextMenuIcon } from "lib/icons/contextMenu";

export const ButtonContextMenu = (props) => (
  <Button {...props}><ContextMenuIcon boxSize="16px" /></Button>
);
